import React from "react";
import styled from "styled-components";

import {
  BarChart,
  Category as CategoryIcon,
  CurrencyExchange,
  Dashboard,
  RssFeed as RssFeedIcon,
  Settings as SettingsIcon,
  ShowChart as ShowChartIcon,
  Store as StoreIcon,
} from "../../common/icons";
import useNavigationCollapse from "../../hooks/useNavigationCollapse";
import useRoutes from "../../hooks/useRoutes";
import NavigationCollapseIcon from "./components/NavigationCollapseIcon";
import NavigationItem from "./components/NavigationItem";
import NavigationLogo from "./components/NavigationLogo";
import UserOptions from "./components/UserOptions";

const Navigation = () => {
  const { isCollapsed } = useNavigationCollapse();
  const { routes } = useRoutes();

  return (
    <Container $isCollapsed={isCollapsed}>
      <StyledNavigationCollapseIcon />
      <StyledLogoContainer $isCollapsed={isCollapsed}>
        <NavigationLogo />
      </StyledLogoContainer>
      <UserOptions />
      <NavigationContainerStyle>
        <NavigationItem label={routes.root.name} to={routes.root.url} exact icon={<Dashboard />} />
        <NavigationItem label={routes.feeds.name} to={routes.feeds.url} icon={<RssFeedIcon />} />
        <NavigationItem
          label={routes.instruments.name}
          to={routes.instruments.url}
          icon={<ShowChartIcon />}
        />
        <NavigationItem
          label={routes.categories.name}
          to={routes.categories.url}
          icon={<CategoryIcon />}
        />
        <NavigationItem
          label={routes.exchanges.name}
          to={routes.exchanges.url}
          icon={<StoreIcon />}
        />
        <NavigationItem
          label={routes.dualCharts.name}
          to={routes.dualCharts.url}
          icon={<BarChart />}
        />
        <NavigationItem
          label={routes.suspended.name}
          to={routes.suspended.url}
          icon={<CurrencyExchange />}
        />
        <NavigationItem label="Settings" icon={<SettingsIcon />}>
          <NavigationItem label={routes.users.name} to={routes.users.url} isSubItem />
          <NavigationItem label={routes.roles.name} to={routes.roles.url} isSubItem />
        </NavigationItem>
      </NavigationContainerStyle>
    </Container>
  );
};

export default Navigation;

const Container = styled.div<{ $isCollapsed?: boolean }>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  transition: width 0.2s linear;
  width: ${({ $isCollapsed }) => ($isCollapsed ? 81 : 276)}px;
  padding: 16px;
  background: ${({ theme }) => theme.colors.bg.primary};
  border-right: 1px solid ${({ theme }) => theme.colors.bg.divider};
  flex-shrink: 0;
`;

const NavigationContainerStyle = styled.div`
  flex: 1;
  overflow-y: auto;
`;

const StyledLogoContainer = styled.div<{ $isCollapsed?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isCollapsed }) => ($isCollapsed ? "center" : "flex-start")};
  padding: 19px 6px;
  padding-top: ${({ $isCollapsed }) => ($isCollapsed ? "22px" : "19px")};
`;

const StyledNavigationCollapseIcon = styled(NavigationCollapseIcon)`
  position: absolute;
  right: -12px;
  top: 74px;
  z-index: 100;
`;
